import { render, staticRenderFns } from "./Game_vision.vue?vue&type=template&id=bfab55cc&style=true"
import script from "./Game_vision.vue?vue&type=script&lang=js"
export * from "./Game_vision.vue?vue&type=script&lang=js"
import style0 from "./Game_vision.vue?vue&type=style&index=0&id=bfab55cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports